var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      attrs: {
        row: "",
        "align-start": "",
        "justify-space-between": "",
        wrap: ""
      }
    },
    [
      _c("div", { staticClass: "input-field-container small" }, [
        _c("label", { staticClass: "required" }, [
          _vm._v(_vm._s(_vm.$tc("Code", 1)))
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.customField.code,
              expression: "customField.code"
            }
          ],
          staticClass: "input-field",
          attrs: { id: "code", type: "text", disabled: _vm.disableFields },
          domProps: { value: _vm.customField.code },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.customField, "code", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "input-field-container small" }, [
        _c("label", { staticClass: "required" }, [
          _vm._v(" " + _vm._s(_vm.$tc("Label", 1)) + " ")
        ]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.customField.label,
              expression: "customField.label"
            }
          ],
          staticClass: "input-field",
          attrs: { id: "label", type: "text", disabled: _vm.disableFields },
          domProps: { value: _vm.customField.label },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.customField, "label", $event.target.value)
            }
          }
        })
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-field-container small" },
        [
          _c("label", { staticClass: "required" }, [
            _vm._v(_vm._s(_vm.$tc("Object", 1)))
          ]),
          _vm._v(" "),
          _c("treeselect", {
            attrs: {
              options: _vm.customFieldObjectOptions,
              disableFuzzyMatching: "",
              disabled: _vm.disableFields,
              disableBranchNodes: ""
            },
            model: {
              value: _vm.objectValue,
              callback: function($$v) {
                _vm.objectValue = $$v
              },
              expression: "objectValue"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-field-container small" },
        [
          _c("label", { staticClass: "required" }, [
            _vm._v(_vm._s(_vm.$tc("Type", 1)))
          ]),
          _vm._v(" "),
          _c("treeselect", {
            attrs: {
              options: _vm.fieldTypes,
              disableFuzzyMatching: "",
              disabled: _vm.disableFields
            },
            model: {
              value: _vm.customField.input_type,
              callback: function($$v) {
                _vm.$set(_vm.customField, "input_type", $$v)
              },
              expression: "customField.input_type"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-field-container small" },
        [
          _c("label", [_vm._v(_vm._s(_vm.$t("List")))]),
          _vm._v(" "),
          _c("treeselect", {
            attrs: {
              options: _vm.customLists,
              disableFuzzyMatching: "",
              disabled:
                _vm.disableFields ||
                !(
                  _vm.customField.input_type === "select" ||
                  _vm.customField.input_type === "multiselect"
                )
            },
            model: {
              value: _vm.customField.list_name,
              callback: function($$v) {
                _vm.$set(_vm.customField, "list_name", $$v)
              },
              expression: "customField.list_name"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "input-field-container small" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-field-container small" },
        [
          _c("label", [_vm._v(_vm._s(_vm.$t("DefaultValue")))]),
          _vm._v(" "),
          (_vm.customField.input_type === "text" ||
          _vm.customField.input_type === "textarea"
            ? "text"
            : "number") === "checkbox" &&
          (_vm.customField.input_type === "text" ||
            _vm.customField.input_type === "textarea" ||
            _vm.customField.input_type === "float" ||
            _vm.customField.input_type === "int")
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.customField.default_value,
                    expression: "customField.default_value"
                  }
                ],
                staticClass: "input-field",
                attrs: {
                  id: "default",
                  disabled:
                    _vm.disableFields ||
                    _vm.customField.input_type === undefined,
                  type: "checkbox"
                },
                domProps: {
                  checked: Array.isArray(_vm.customField.default_value)
                    ? _vm._i(_vm.customField.default_value, null) > -1
                    : _vm.customField.default_value
                },
                on: {
                  change: function($event) {
                    var $$a = _vm.customField.default_value,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 &&
                          _vm.$set(
                            _vm.customField,
                            "default_value",
                            $$a.concat([$$v])
                          )
                      } else {
                        $$i > -1 &&
                          _vm.$set(
                            _vm.customField,
                            "default_value",
                            $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                          )
                      }
                    } else {
                      _vm.$set(_vm.customField, "default_value", $$c)
                    }
                  }
                }
              })
            : (_vm.customField.input_type === "text" ||
              _vm.customField.input_type === "textarea"
                ? "text"
                : "number") === "radio" &&
              (_vm.customField.input_type === "text" ||
                _vm.customField.input_type === "textarea" ||
                _vm.customField.input_type === "float" ||
                _vm.customField.input_type === "int")
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.customField.default_value,
                    expression: "customField.default_value"
                  }
                ],
                staticClass: "input-field",
                attrs: {
                  id: "default",
                  disabled:
                    _vm.disableFields ||
                    _vm.customField.input_type === undefined,
                  type: "radio"
                },
                domProps: {
                  checked: _vm._q(_vm.customField.default_value, null)
                },
                on: {
                  change: function($event) {
                    return _vm.$set(_vm.customField, "default_value", null)
                  }
                }
              })
            : _vm.customField.input_type === "text" ||
              _vm.customField.input_type === "textarea" ||
              _vm.customField.input_type === "float" ||
              _vm.customField.input_type === "int"
            ? _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.customField.default_value,
                    expression: "customField.default_value"
                  }
                ],
                staticClass: "input-field",
                attrs: {
                  id: "default",
                  disabled:
                    _vm.disableFields ||
                    _vm.customField.input_type === undefined,
                  type:
                    _vm.customField.input_type === "text" ||
                    _vm.customField.input_type === "textarea"
                      ? "text"
                      : "number"
                },
                domProps: { value: _vm.customField.default_value },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.customField,
                      "default_value",
                      $event.target.value
                    )
                  }
                }
              })
            : _vm.customField.input_type === "checkbox"
            ? _c("treeselect", {
                attrs: {
                  options: _vm.booleanOptions,
                  disableFuzzyMatching: "",
                  disabled:
                    _vm.disableFields ||
                    _vm.customField.input_type === undefined
                },
                model: {
                  value: _vm.customField.default_value,
                  callback: function($$v) {
                    _vm.$set(_vm.customField, "default_value", $$v)
                  },
                  expression: "customField.default_value"
                }
              })
            : _vm.customField.input_type === "date"
            ? _c(
                "v-menu",
                {
                  attrs: {
                    "close-on-content-click": false,
                    "nudge-right": 40,
                    lazy: "",
                    transition: "scale-transition",
                    "offset-y": "",
                    "full-width": "",
                    "min-width": "290px",
                    disabled:
                      _vm.disableFields ||
                      _vm.customField.input_type === undefined
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        return [
                          _c(
                            "v-text-field",
                            _vm._g(
                              {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  "append-icon": "event",
                                  readonly: "",
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.customField.default_value,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.customField,
                                      "default_value",
                                      $$v
                                    )
                                  },
                                  expression: "customField.default_value"
                                }
                              },
                              on
                            )
                          )
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.startDateMenu,
                    callback: function($$v) {
                      _vm.startDateMenu = $$v
                    },
                    expression: "startDateMenu"
                  }
                },
                [
                  _vm._v(" "),
                  _c("v-date-picker", {
                    attrs: { max: _vm.today, color: "accent", "no-title": "" },
                    on: {
                      input: function($event) {
                        _vm.startDateMenu = false
                      }
                    },
                    model: {
                      value: _vm.customField.default_value,
                      callback: function($$v) {
                        _vm.$set(_vm.customField, "default_value", $$v)
                      },
                      expression: "customField.default_value"
                    }
                  })
                ],
                1
              )
            : _vm.customField.input_type === "datetime"
            ? _c("input-field", {
                staticClass: "input-field",
                staticStyle: {
                  "padding-bottom": "0px",
                  display: "flex",
                  "align-items": "center"
                },
                attrs: {
                  label: "",
                  "input-type": "datetime",
                  size: "large",
                  id: "datetimepicker",
                  "field-disabled":
                    _vm.disableFields ||
                    _vm.customField.input_type === undefined
                },
                model: {
                  value: _vm.customField.default_value,
                  callback: function($$v) {
                    _vm.$set(_vm.customField, "default_value", $$v)
                  },
                  expression: "customField.default_value"
                }
              })
            : _vm.customField.input_type === "select" ||
              _vm.customField.input_type === "multiselect"
            ? _c("treeselect", {
                attrs: {
                  options: _vm.list,
                  disableFuzzyMatching: "",
                  multiple:
                    _vm.customField.input_type === "multiselect" ? true : false,
                  disabled:
                    _vm.disableFields ||
                    _vm.customField.input_type === undefined ||
                    _vm.customField.list_name === undefined
                },
                model: {
                  value: _vm.customField.default_value,
                  callback: function($$v) {
                    _vm.$set(_vm.customField, "default_value", $$v)
                  },
                  expression: "customField.default_value"
                }
              })
            : _c("input", {
                staticClass: "input-field",
                attrs: { disabled: "true" }
              })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-field-container small" },
        [
          _c("label", [_vm._v(_vm._s(_vm.$t("Required")))]),
          _vm._v(" "),
          _c("v-checkbox", {
            attrs: {
              id: "required",
              disabled: _vm.disableFields,
              ripple: false,
              color: "#4fa2b7",
              disableFuzzyMatching: ""
            },
            model: {
              value: _vm.customField.required,
              callback: function($$v) {
                _vm.$set(_vm.customField, "required", $$v)
              },
              expression: "customField.required"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "input-field-container small" },
        [
          _c("label", { staticClass: "required" }, [
            _vm._v(_vm._s(_vm.$tc("Size", 1)))
          ]),
          _vm._v(" "),
          _c("treeselect", {
            attrs: {
              options: _vm.customFieldSizeOptions,
              disableFuzzyMatching: "",
              disabled: _vm.disableFields
            },
            model: {
              value: _vm.customField.size,
              callback: function($$v) {
                _vm.$set(_vm.customField, "size", $$v)
              },
              expression: "customField.size"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "input-field-container small" }, [
        _c("label", [_vm._v(" " + _vm._s(_vm.$t("Index")) + " ")]),
        _vm._v(" "),
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.customField.index,
              expression: "customField.index"
            }
          ],
          staticClass: "input-field",
          attrs: { id: "index", type: "number", disabled: _vm.disableFields },
          domProps: { value: _vm.customField.index },
          on: {
            input: function($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.customField, "index", $event.target.value)
            }
          }
        })
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0276f5a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0276f5a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SystemManagement/SystemSettings/CustomFields/CustomFieldFields.vue
// module id = null
// module chunks = 